import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { EInvoiceSignUpDialogComponent } from './e-invoice-sign-up-dialog/e-invoice-sign-up-dialog.component';
import { IEInvoiceSubscription } from './models/e-invoice-subscription.interface';

@Component({
  selector: 'upsc-e-invoice-sign-up',
  templateUrl: './e-invoice-sign-up.component.html',
  styleUrls: ['./e-invoice-sign-up.component.scss'],
})
export class EInvoiceSignUpComponent implements OnInit {
  @Input() isFullWidth = false;
  @Output() subscriptionChanged: EventEmitter<IEInvoiceSubscription> = new EventEmitter<IEInvoiceSubscription>();

  constructor(private dialog: MatDialog) {
  }

  public ngOnInit() {
  }

  public openEInvoiceSignUpDialog(event) {
    event.preventDefault();

    const dialogConfig: MatDialogConfig = {
      disableClose: false,
    };

    const dialogRef: MatDialogRef<EInvoiceSignUpDialogComponent> = this.dialog.open(EInvoiceSignUpDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      (result) => {
        if (!result) {
          return;
        }

        this.subscriptionChanged.emit(result);
      },
    );
  }
}
